export default "__VITE_ASSET__DgEG5rvY__"